import { Stack } from "@mantine/core";
import Checkbox from "@/components/atoms/Checkbox";

export interface FilterCheckboxOption {
  value: string;
  label: string;
  testId?: string;
}

interface FilterCheckboxListProps {
  options: FilterCheckboxOption[];
  /** Values of the ticked options */
  selected: string[];
  /** Called with the value that was clicked. The page decides what that means (add, remove, replace). */
  onToggle: (value: string) => void;
  /** Names the group for screen readers */
  ariaLabel?: string;
  "data-testid"?: string;
}

/** A vertical list of checkboxes for a FilterSection. */
export default function FilterCheckboxList({
  options,
  selected,
  onToggle,
  ariaLabel,
  "data-testid": dataTestId,
}: FilterCheckboxListProps) {
  return (
    <Stack gap="0.75rem" role="group" aria-label={ariaLabel} data-testid={dataTestId}>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={selected.includes(option.value)}
          onChange={() => onToggle(option.value)}
          data-testid={option.testId}
        />
      ))}
    </Stack>
  );
}
